import {
  clearStoredOperatorContext,
  commitOperatorContext,
  operatorContextCleared,
} from './operatorContext';
import { PLATFORM_OPERATOR_CONTEXT } from './operatorContext.contract';
import { coachingAnalyticsApi } from '../coachingAnalytics/coachingAnalytics.api';
import { coachingDashboardApi } from '../coachingDashboard/coachingDashboard.api';
import { institutionAdminApi } from '../institutionAdmin/institutionAdmin.api';
import type { AppDispatch, RootState } from '../store';

/**
 * The context rides a header rather than the query arguments, so an entry cached under the
 * previous operator answers to the same key.
 */
const resetOperatorScopedApiState = (dispatch: AppDispatch): void => {
  dispatch(coachingDashboardApi.util.resetApiState());
  dispatch(coachingAnalyticsApi.util.resetApiState());
  dispatch(institutionAdminApi.util.resetApiState());
};

export const selectOperatorInstitution =
  (institutionId: number) =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const state = getState();

    dispatch(
      commitOperatorContext({
        institutionId,
        ownerUserId: state.user.user?.id ?? null,
        heldRoots: state.operatorContext.heldRoots,
      }),
    );
    resetOperatorScopedApiState(dispatch);
  };

export const selectPlatformMode =
  () =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const state = getState();

    dispatch(
      commitOperatorContext({
        institutionId: PLATFORM_OPERATOR_CONTEXT,
        ownerUserId: state.user.user?.id ?? null,
        heldRoots: state.operatorContext.heldRoots,
      }),
    );
    resetOperatorScopedApiState(dispatch);
  };

export const clearOperatorContext =
  () =>
  (dispatch: AppDispatch): void => {
    clearStoredOperatorContext();
    dispatch(operatorContextCleared());
    resetOperatorScopedApiState(dispatch);
  };
